export default __webpack_public_path__ + "static/media/pikachu.397d262a.gif";